import { render } from "./confirmOrder.vue?vue&type=template&id=5fdb973a&scoped=true"
import script from "./confirmOrder.vue?vue&type=script&lang=js"
export * from "./confirmOrder.vue?vue&type=script&lang=js"

import "./confirmOrder.vue?vue&type=style&index=0&id=5fdb973a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdb973a"]])

export default __exports__